import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../../actionTypes';

const initialState = {
  auditModelId: null,
  dealerId: null,
  groupId: null,
};

const updateData = (state, { payload }) => ({
  ...state,
  ...payload,
});

const resetData = (state, { payload }) => ({
  ...state,
  ...payload,
});

export default createReducer(initialState, {
  [types.DISPLAY_DUPLICATE_MODAL]: updateData,
  [types.HIDE_DUPLICATE_MODAL]: resetData,
  [types.SET_DUPLICATE_MODAL_DATA]: updateData,
});
